import { type Customer, customerInTrial } from 'src/data/customer';
// @ts-expect-error - no TypeScript definitions yet
import { getCustomerPlan, isPlanFromBasicCategory } from 'src/data/subscription';

export const FEATURE_ACCESS = {
  liveScoring: 'live_scoring',
  refundFlaggedVariations: 'refund_flagged_variations',
  freemiumAllowed: 'freemium_allowed',
} as const;
export type FeatureAccess = (typeof FEATURE_ACCESS)[keyof typeof FEATURE_ACCESS];

export const customerCanAccessFeature = (customer: Customer, feature: FeatureAccess): boolean => {
  const featureAccess = customer?.featureAccess || [];
  return featureAccess.includes(feature);
};

export const customerHasLiveScoring = (customer: Customer): boolean =>
  customerCanAccessFeature(customer, FEATURE_ACCESS.liveScoring);

export const customerHasRefundFlaggedVariations = (customer: Customer): boolean =>
  customerCanAccessFeature(customer, FEATURE_ACCESS.refundFlaggedVariations);

export const customerFreemiumAllowed = (customer: Customer): boolean =>
  customerCanAccessFeature(customer, FEATURE_ACCESS.freemiumAllowed);

export const customerCanChangeGenerationLanguage = (customer: Customer): boolean => {
  const isCustomerInTrial = customerInTrial(customer);
  const plan = getCustomerPlan(customer);
  return !isPlanFromBasicCategory(plan) || isCustomerInTrial;
};

export const customerCanChangeNumberOfVariations = (customer: Customer): boolean => {
  const isCustomerInTrial = customerInTrial(customer);
  const plan = getCustomerPlan(customer);
  return !isPlanFromBasicCategory(plan) || isCustomerInTrial;
};
